import { Link } from "react-router-dom";
import PublicNav, { PublicFooter } from "../components/PublicNav";
export default function HelpPage({
  publicMode = false,
}: {
  publicMode?: boolean;
}) {
  const content = (
    <>
      <div className="page-title">
        <div>
          <span className="eyebrow">WE'RE HERE TO HELP</span>
          <h1>A clearer path forward.</h1>
          <p>
            Answers to the essentials, and a real address when you need a hand.
          </p>
        </div>
      </div>
      <div className="help-grid">
        {[
          [
            "How do credits work?",
            "One credit unlocks one contact and all available fields. Monthly subscribers receive 5,000 credits after each payment; annual subscribers receive 60,000 upfront.",
          ],
          [
            "Can I save contacts before unlocking?",
            "Yes. Select prospects in Find leads and add them to a named list. Saving a contact to a list does not unlock it or spend credits.",
          ],
          [
            "What does the email status mean?",
            "The status is supplied with the imported record. It is not a live mailbox check or a guarantee of deliverability. Catch-all and unknown records may be less reliable.",
          ],
          [
            "Can I download contacts again?",
            "Yes. Export unlocked contacts from My lists at no additional credit cost. Your unlocked contacts remain accessible after subscription cancellation, subject to data suppression requests.",
          ],
          [
            "How does the annual offer work?",
            "Eligible first-time customers can use SALES120 for 50% off their first $240 annual payment. You pay $120 for year one, then $240/year. Monthly plans are not discounted.",
          ],
          [
            "How can I cancel?",
            "Open Billing and choose Manage subscription to use the Stripe billing portal. Cancellation takes effect at the end of your paid subscription period.",
          ],
        ].map(([q, a]) => (
          <article className="panel" key={q}>
            <h2>{q}</h2>
            <p>{a}</p>
          </article>
        ))}
      </div>
      <section className="support-banner">
        <span>✉</span>
        <div>
          <h2>Let's get you unstuck.</h2>
          <p>
            Questions about an import status, a contact, or your subscription?
          </p>
          <a href="mailto:support@reachatlasleads.com">
            support@reachatlasleads.com ↗
          </a>
        </div>
      </section>
      <p className="fine-print">
        <Link to="/privacy">Privacy policy</Link> ·{" "}
        <Link to="/terms">Terms</Link> ·{" "}
        <Link to="/opt-out">Remove my data</Link>
      </p>
    </>
  );
  return publicMode ? (
    <div className="public-site">
      <PublicNav />
      <main className="public-section">{content}</main>
      <PublicFooter />
    </div>
  ) : (
    content
  );
}
